(() => {
  const website = 'https://www.iris-studio.de';
  const key = 'iris-journey-v1';
  function remember() {
    if (!/^\/(products\/[^/]+|cart)\/?$/.test(location.pathname)) return;
    const url = new URL(location.pathname, location.origin);
    url.searchParams.set('view', 'iris');
    const variant = document.querySelector('[data-iris-variant]')?.value;
    if (/^\d+$/.test(variant || '')) url.searchParams.set('variant', variant);
    const context = {path:url.pathname+url.search, time:Date.now()};
    try { sessionStorage.setItem(key, JSON.stringify(context)); } catch {}
    return context;
  }
  function context() {
    const current=remember();
    if(current) return current;
    try { const old=JSON.parse(sessionStorage.getItem(key)); if(old && Date.now()-old.time<7200000) return old; } catch {}
  }
  function prepare(link) {
    let url; try {url=new URL(link.href);} catch {return;}
    if(url.origin!==website) return;
    const current=context();
    if(current) {url.searchParams.set('iris_return',current.path);url.searchParams.set('iris_shop',location.hostname);link.href=url.href;}
  }
  document.addEventListener('pointerdown',e=>{const a=e.target.closest('a[href]');if(a) prepare(a);},true);
  document.addEventListener('click',e=>{const a=e.target.closest('a[href]');if(a) prepare(a);},true);
  document.addEventListener('focusin',e=>{const a=e.target.closest('a[href]');if(a) prepare(a);});
  window.addEventListener('pagehide',remember);
})();
